export function initMobileDrawerEngine() {
  function bindDrawerEvents() {
    const trigger = document.getElementById('sffMobile3DDrawerTrigger');
    const closeBtn = document.getElementById('sffDrawerCloseBtn');
    const backdrop = document.getElementById('sffDrawerBackdrop');
    const drawerNav = document.getElementById('sffMobileDrawerNav');
    const sidebarLeft = document.getElementById('sffSidebarLeft');
    const sidebarRight = document.getElementById('sffSidebarRight');
    const tabs = document.querySelectorAll('.sff-drawer-tab');
    let activeMobileTab = 'left';

    if (!trigger || !sidebarLeft || !sidebarRight) return;

    function updatePanelVisibility() {
      if (activeMobileTab === 'left') {
        sidebarLeft.classList.add('mobile-drawer-open');
        sidebarRight.classList.remove('mobile-drawer-open');
      } else {
        sidebarRight.classList.add('mobile-drawer-open');
        sidebarLeft.classList.remove('mobile-drawer-open');
      }
    }

    function openDrawer(event) {
      event?.preventDefault?.();
      backdrop?.classList.add('active');
      drawerNav?.classList.add('active');
      document.body.style.overflow = 'hidden';
      updatePanelVisibility();
    }

    function closeDrawer(event) {
      event?.preventDefault?.();
      backdrop?.classList.remove('active');
      drawerNav?.classList.remove('active');
      sidebarLeft.classList.remove('mobile-drawer-open');
      sidebarRight.classList.remove('mobile-drawer-open');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    backdrop?.addEventListener('click', closeDrawer);
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(item => item.classList.remove('active'));
        tab.classList.add('active');
        activeMobileTab = tab.getAttribute('data-target');
        updatePanelVisibility();
      });
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && drawerNav?.classList.contains('active')) closeDrawer(event);
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1024) closeDrawer();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindDrawerEvents, { once:true });
  else bindDrawerEvents();
}
